export enum Role {
    Admin = 0,
    Support = 1,
    Doctor = 2
}